var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.container,attrs:{"data-luko-tracking":"VimeoSection"}},[_c('iframe',{attrs:{"src":_vm.content.vimeo_url.url,"width":"694","height":"390","frameborder":"0","allow":"autoplay; fullscreen","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }